import restClient from './restClient';
import { apiMap } from '../utilities';

const doctorService = {
  getClinicDetails: (clinicID: string) => {
    return restClient.makeGetRequest(apiMap.getClinicDetails(clinicID));
  },

  getAggregateDoctors: (params: { userID: string; mobileNumber: string; offset?: number, page?: number, type?: string }) => {
    return restClient.makeGetRequest(apiMap.getAggregateData(params.userID), {
      page: 1, offset: 20, type: 'doctor',
      ...params,
    });
  },

  getClinics(doctorID: string) {
    return restClient.makeGetRequest(apiMap.getClinics(), { doctorID });
  },

  getVcPrice(doctorId: string) {
    return restClient.makeGetRequest(apiMap.getVcPrice(), { doctorId });
  },

  getDoctorDetails(shortUrl: string) {
    return restClient.makeGetRequest(apiMap.getDoctorDetails(shortUrl));
  },

  searchDoctor(name: string, locality: string | undefined = 'mumbai') {
    return restClient.makeGetRequest(apiMap.searchDoctor(), { locality, name });
  },

};

export default doctorService;